import React from 'react';
import { atom } from 'recoil';

interface Breadcrumb {
  key?: string;
  label?: string;
  path: string;
}

export const contentHeaderAtom = atom<React.ReactNode | null>({
  key: 'contentHeaderAtom',
  default: null
})

export const breadcrumbsAtom = atom<Breadcrumb[] | null>({
  key: 'breadcrumbsAtom',
  default: []
})


